import { fromJS } from 'immutable';
import * as widgetActions from '../actions/widget';
import { SUCCESS, START, ERROR } from '../actions/global';
import { fetchingState, defaultPageSize } from '@constants';

const initialStats = {
  widgetList: {
    pageSize: defaultPageSize,
    sortModel: [],
    currentPage: 0,
  },
  widget: {},
  widgetInfo: {},
  codefiles: {},
};

export default (state = fromJS(initialStats), action) => {
  let newState;
  switch (action.type) {
    case widgetActions.WIDGET_FETCH_ALL[START]:
      return state.setIn(['widgetList', 'state'], fetchingState.FETCHING);
    case widgetActions.WIDGET_FETCH_ALL[SUCCESS]:
      newState = state.setIn(['widgetList', 'state'], fetchingState.LOADED);
      // newState = newState.setIn([ 'widgetList', 'totalCount' ], (action.data && action.data.totalWidget) ? action.data.totalWidget.widgetCount : 0);
      return newState.setIn(
        ['widgetList', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case widgetActions.WIDGET_FETCH_ALL[ERROR]:
      return state.setIn(['widgetList', 'state'], fetchingState.ERROR);

    case widgetActions.WIDGET_FETCH_SINGLE[START]:
      newState = state.setIn(['widget', 'data'], fromJS(null));
      newState = newState.setIn(['widgetInfo', 'data'], fromJS(null));
      return newState.setIn(['widget', 'state'], fetchingState.FETCHING);
    case widgetActions.WIDGET_FETCH_SINGLE[SUCCESS]:
      newState = state.setIn(['widget', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['widget', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case widgetActions.WIDGET_FETCH_SINGLE[ERROR]:
      return state.setIn(['widget', 'state'], fetchingState.ERROR);

    case widgetActions.WIDGET_FETCH_INFO[START]:
      newState = state.setIn(['widgetInfo', 'data'], fromJS(null));
      return newState.setIn(['widgetInfo', 'state'], fetchingState.FETCHING);
    case widgetActions.WIDGET_FETCH_INFO[SUCCESS]:
      newState = state.setIn(['widgetInfo', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['widgetInfo', 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );
    case widgetActions.WIDGET_FETCH_INFO[ERROR]:
      return state.setIn(['widgetInfo', 'state'], fetchingState.ERROR);

    case widgetActions.WIDGET_UPDATE[START]:
      return state.setIn(['widget', 'state'], fetchingState.SAVING);
    case widgetActions.WIDGET_UPDATE[ERROR]:
      return state.setIn(['widget', 'state'], fetchingState.ERROR);
    case widgetActions.WIDGET_UPDATE[SUCCESS]:
      newState = state.setIn(['widget', 'state'], fetchingState.LOADED);
      return newState.setIn(['widget', 'data'], fromJS(action.data.results[0]));

    case widgetActions.WIDGET_LOAD_CODEFILES[SUCCESS]:
      return state.setIn(
        ['codefiles', action.name],
        fromJS(action.data.results),
      );

    case widgetActions.WIDGET_UPDATE_INFO[START]:
      return state.setIn(['widgetInfo', 'state'], fetchingState.SAVING);
    case widgetActions.WIDGET_UPDATE_INFO[ERROR]:
      return state.setIn(['widgetInfo', 'state'], fetchingState.ERROR);
    case widgetActions.WIDGET_UPDATE_INFO[SUCCESS]:
      newState = state.setIn(['widgetInfo', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['widgetInfo', 'data'],
        fromJS(action.data.results[0]),
      );

    case widgetActions.WIDGET_RESET_DATA:
      return state.setIn(['widget'], fromJS({}));
    case widgetActions.WIDGET_CREATE[START]:
      return state.setIn(['widget', 'state'], fetchingState.SAVING);
    case widgetActions.WIDGET_CREATE[SUCCESS]:
      newState = state.setIn(['widget', 'state'], fetchingState.LOADED);
      return newState.setIn(['widget', 'data'], fromJS(action.data.results[0]));
    case widgetActions.WIDGET_CREATE[ERROR]:
      return state.setIn(['widget', 'state'], fetchingState.ERROR);

    default:
      return state;
  }
};
